
<quant-modal [responsiveStyles]="true" *ngIf="deviceSettingsService">
  <div class="modal-container">
    <div class="title">{{'settings.DEVICE_SETTINGS' | transloco}}</div>
    <app-device-settings-content
      [deviceSettingsService]="deviceSettingsService"
      *ngIf="!controlService?.isVisualAidCall"
    />
    <app-visual-aid-device-settings-content
      [deviceSettingsService]="deviceSettingsService"
      [inModal]="true"
      *ngIf="controlService?.isVisualAidCall"
    />

    <div class="line"></div>
    <footer>
      <quant-button
        type="button"
        [label]="'settings.CONFIRM_SETTINGS' | transloco"
        hierarchy="primary"
        size="md"
        (click)="deviceSettingsService.confirmSettings()"
        [disabled]="!deviceSettingsService.audioDeviceSelected || deviceSettingsService.isDiagnosticRunning"
      ></quant-button>
    </footer>
  </div>
</quant-modal>
